import { useSelector } from 'react-redux';

export const Score = () => {
  const scoreUser = useSelector((state) => state.score.scoreUser);
  const scoreComputer = useSelector((state) => state.score.scoreComputer);

  return (
    <div className='scoreboard__score score'>
      <div className='score__gamer'>{scoreUser}</div>
      <div className='score__divider'>-</div>
      <div className='score__computer'>{scoreComputer}</div>
    </div>
  );
};
